import useDeviceDetect from 'src/common/hooks/useDeviceDetect'
import Img from 'src/components/shared/Img'
import { data, whoWeHelpStatesData } from './consts'
import { NextSeo } from 'next-seo'

const BannerImageDesktop = ({ showTrustPilot }) => (
  <Img
    src="/next-assets/brand-pages/heros/desktop/who-we-help-states.webp"
    alt="a girl smiling looking at the horizon"
    layout="fill"
    objectFit="cover"
    className={`my-auto flex w-full flex-col justify-center ${
      showTrustPilot ? 'lg:h-175' : 'lg:h-[622px]'
    } lg:pl-38`}
    imgClassName="m-auto inset-0"
    priority
    isBackgroundImage
  />
)

export const WhoWeHelpStates = () => {
  const { isMobile } = useDeviceDetect()
  const { seo } = whoWeHelpStatesData

  return (
    <>
      <NextSeo {...seo} />
      <div className="lg:h-175 flex flex-col justify-center p-8 text-center lg:p-0 lg:text-left">
        {!isMobile && <BannerImageDesktop />}
        <div className="w-content w-full lg:px-8">
          <h1 className="lg:text-normal mb-0 pb-0 text-3.5xl font-bold leading-11 text-black-base lg:whitespace-pre-line lg:text-57 lg:font-light lg:leading-15 lg:text-white">
            Where we operate
          </h1>
        </div>
      </div>
      <div className="w-content w-full p-8">
        <h2 className="heading-2 mt-0 mb-14 p-0 text-center">
          Freedom Debt Relief, LLC holds licenses in the following states
        </h2>
        <div className="overflow-x-auto">
          <table className=" lg:max-w-auto  max-w-100 m-auto divide-y divide-gray-200">
            <thead className="bg-gray-50 font-bold">
              <tr>
                <th className="px-6 py-3 text-left text-xs tracking-wider text-gray-500">
                  State
                </th>
                <th className="px-6 py-3 text-left text-xs font-bold tracking-wider text-gray-500">
                  License Name
                </th>
                <th className="px-6 py-3 text-right text-xs font-bold tracking-wider text-gray-500">
                  License/Registration Number:
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white">
              {data.licenses.map((license) => (
                <tr key={license.state}>
                  <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                    {license.state}
                  </td>
                  <td
                    className="whitespace-nowrap px-6 py-4 text-sm text-gray-500"
                    dangerouslySetInnerHTML={{
                      __html: license.licenseName,
                    }}
                  />
                  <td className="whitespace-nowrap px-6 py-4 text-right text-sm text-gray-500">
                    <div
                      className="max-w-75 lg:max-w-full"
                      dangerouslySetInnerHTML={{
                        __html: license.registrationNumber,
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}

export default WhoWeHelpStates
